import { Licenses } from "@nova/constants"
import { useAppSelector } from "integrations/redux/hooks"
import { selectIsDomainWhiteListed, selectUserLicense } from "user/profile/selectors"
import { LicenseCapacitiesInBytes } from "../module"

export const useUsageExceeded = () => {
    const license = useAppSelector(selectUserLicense)
    const isDomainWhiteListed = useAppSelector(selectIsDomainWhiteListed)

    const usage = license?.usageAmount ?? Infinity
    const isExceeded =
        !license ||
        (usage >= LicenseCapacitiesInBytes[license.subscriptionType as Licenses] &&
            !isDomainWhiteListed)
    return { isExceeded }
}
